import { render, staticRenderFns } from "./course-files.html?vue&type=template&id=d4f9b47e&scoped=true&"
import script from "./course-files.js?vue&type=script&lang=js&"
export * from "./course-files.js?vue&type=script&lang=js&"
import style0 from "./course-files.scss?vue&type=style&index=0&id=d4f9b47e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f9b47e",
  null
  
)

export default component.exports